<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm bảng giá tính lương tỉnh (VP liên kết)</div>
      <div v-else>Chỉnh sửa bảng giá tính lương tỉnh (VP liên kết)</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm mới'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <label class="p-col-2 txt-left">Mã VP liên kết*</label>
          <div class="p-col-10">
            <Dropdown id="office_vplk_id" :showClear="true" :filter="true" :disabled="this.disableEdit"
              v-model="office_vplk_id" :options="listOfficevplk" optionLabel="code" @change="onChangevplk($event)"
              placeholder="Chọn 1 mã văn phòng liên kết"/>
              <small
                v-if="validationErrors && validationErrors['office_vplk_id']"
                class="p-invalid"
              >{{validationErrors['office_vplk_id']}}</small>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 15px;">
          <label class="p-col-2 txt-left">Tỉnh/ Thành phố*</label>
          <div class="p-col-10" v-if="this.mode !== 'edit'">
            <Dropdown id="state_id" :showClear="true" :filter="true" :disabled="this.disablestate"
              v-model="selectedState" :options="this.listState" optionLabel="name" @change="onChangestate($event)"
              placeholder="Chọn 1 Tỉnh/ Thành phố"/>
              <small
                v-if="validationErrors && validationErrors['state_id']"
                class="p-invalid"
              >{{validationErrors['state_id']}}</small>
          </div>
          <div class="p-col-10" v-else>
            <Dropdown id="state_id" :showClear="true" :filter="true" :disabled="this.disableEdit"
              v-model="selectedState" :options="this.listState"
              optionLabel="name"/>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 15px;">
          <label class="p-col-2 txt-left">Mã VP thừa phát lại*</label>
          <div class="p-col-10" v-if="this.mode !== 'edit'">
            <MultiSelect v-model="selectedTpl" :options="this.listOfficeTpl" :disabled="this.disabledTpl"
              optionLabel="code" placeholder="Chọn 1 hoặc nhiều mã VP Thừa phát lại" :filter="true">
              </MultiSelect>
              <small
                v-if="validationErrors && validationErrors['office_tpl_id']"
                class="p-invalid"
              >{{validationErrors['office_tpl_id']}}</small>
          </div>
          <div v-else class="p-col-10">
            <InputText id="office_tpl_code" :disabled="this.disableEdit"
              v-model="office_tpl_code" /> 
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 15px;">
          <label class="p-col-2 txt-left">Giá (VND)*</label>
          <div class="p-col-10">
            <InputNumber v-model="price" mode="currency" currency="VND" locale="vi-VN"
            />
              <small
                v-if="validationErrors && validationErrors['price']"
                class="p-invalid"
              >{{validationErrors['price']}}</small>
          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      disablestate: true,
      formMode: this.mode,
      disabledTpl: true,
      disableEdit: false,
      selectedTpl: [],
      selectedState: null,
      listState: [],
      price: 0,
      office_tpl_id: null,
      listOfficeTpl: [],
      ward_id: null,
      office_tpl_code: '',
      listSalaryPricelistProvince: [],
      salary_pricelist_province_id: null,
      listOfficevplk: [],
      listOfficevplktpl: [],
      office_vplk_id: null
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.salary_pricelist_province_id = this.$route.params.id
      this.disableEdit = true
    }
    if (this.mode == 'edit') {
      this.disableEdit = true
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async onChangevplk(e) {
      console.log('e', e)
      this.selectedState = null
      this.selectedTpl = []
      this.listOfficeTpl = []
      this.disabledTpl = true
      if (e && e.value != null) {
        this.disablestate = false
      } else {
        this.disablestate = true
      }
    },
    async onChangestate(e) {
      console.log('e', e)
      this.listOfficeTpl = []
      if (e) {
        await this.getTPL(e.value);
      } else {
        this.disabledTpl = true
      }
    },
    async getTPL(state) {
      if (state) {
        let query = `query MyQuery($office_vplk_id: Int!, $state_id: Int!) {
          office_vplk_tpl(where: {office_vplk_id: {_eq: $office_vplk_id}}) {
            office_tpl {
              id
              code
            }
          }
          salary_pricelist_province(where: {office_vplk_id: {_eq: $office_vplk_id}, state_id: {_eq: $state_id}}) {
            office_tpl_id
          }
        }`
        await this.$apollo
          .query({
            query: gql(query),
            variables: {
              state_id: state.id,
              office_vplk_id: this.office_vplk_id.id
            }
          })
          .then(async (res) => {
            console.log('res', res)
            if (res.data.office_vplk_tpl.length > 0) {
              this.listOfficevplktpl = res.data.office_vplk_tpl
              if (this.listOfficevplktpl.length > 0) {
                for (let i = 0; i < this.listOfficevplktpl.length; i++) {
                  const e = this.listOfficevplktpl[i];
                  this.listOfficeTpl.push(e.office_tpl)
                }
                console.log('this.listOfficetpl', this.listOfficeTpl)
                this.disabledTpl = false
                if (res.data.salary_pricelist_province.length >0) {
                  for (let i = 0; i < res.data.salary_pricelist_province.length; i++) {
                    const e = res.data.salary_pricelist_province[i];
                    this.listOfficeTpl = this.listOfficeTpl.filter((elem) => elem.id !== e.office_tpl_id)
                  }
                }
              }
              
            } else {
              this.listOfficetpl = []
              this.disabledTpl = true
            }
        })
      } else {
        this.listOfficetpl = []
        this.disabledTpl = true
      }
    },
    async validateData() {
      this.validationErrors = {};
      var has_error = false
      if (this.mode == 'add') {
        if (!this.office_vplk_id) {
          this.validationErrors['office_vplk_id'] = 'Vui lòng chọn mã văn phòng liên kết';
          has_error = true
        }
        if (!this.selectedState) {
          this.validationErrors['state_id'] = 'Vui lòng chọn Tỉnh/ Thành phố';
          has_error = true
        }
        if (this.selectedTpl.length == 0) {
          this.validationErrors['office_tpl_id'] = 'Vui lòng chọn mã văn phòng TPL';
          has_error = true
        }
      }
      if (this.price === null) {
        this.validationErrors['price'] = 'Vui lòng nhập giá';
        has_error = true
      }
      
      return has_error
    },
    async analyzeData() {
        var data_item= []

        for (let i = 0; i < this.selectedTpl.length; i++) {
          const item = this.selectedTpl[i]
          var data_item_item= {}
          data_item_item['office_vplk_id'] = this.office_vplk_id.id
          data_item_item['state_id'] = this.selectedState.id
          data_item_item['office_tpl_id'] = item.id
          data_item_item['price'] = this.price
          data_item.push(data_item_item)
        }

      return data_item
    },
    async analyzeDataEdit() {
      var data_salary_pricelist_province = {}
        data_salary_pricelist_province['price'] = this.price
      return data_salary_pricelist_province
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_salary_pricelist_province = await this.analyzeData()

        var query = `mutation MyMutation($objects: [salary_pricelist_province_insert_input!]!) {
            insert_salary_pricelist_province(objects: $objects) {
              affected_rows
              returning {
                id
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: data_salary_pricelist_province
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-salary_pricelist_province'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_salary_pricelist_province_update = await this.analyzeDataEdit()
        let query = `mutation MyMutation($salary_pricelist_province_id: Int!, $salary_pricelist_province_update: salary_pricelist_province_set_input) {
          update_salary_pricelist_province(where: {id: {_eq: $salary_pricelist_province_id}}, _set: $salary_pricelist_province_update) {
            affected_rows
            returning {
              id
            }
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              salary_pricelist_province_id: this.salary_pricelist_province_id,
              salary_pricelist_province_update: data_salary_pricelist_province_update,
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-salary_pricelist_province'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    state: {
      query() {
        let query = `
          query MyQuery {
            state(where: {type: {_neq: ${this.$constants.TYPE_STATE.URBAN}}}) {
              id
              name
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.state){
          this.listState = data.state
        }
      },
      fetchPolicy: "network-only"
    },
    office_vplk: {
      query() {
        let query = `
          query MyQuery {
            office_vplk(where: {deleted: {_eq: false}}) {
              id
              code
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.office_vplk){
          this.listOfficevplk = data.office_vplk
        }
      },
      fetchPolicy: "network-only",
    },
    salary_pricelist_province: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            salary_pricelist_province(where: {id: {_eq: $id}}) {
              id
              price
              office_tpl {
                id
                code
              }
              state {
                id
                name 
              }
              office_vplk {
                id
                code
              }
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      async update(data) {
        if(data.salary_pricelist_province){
          this.listSalaryPricelistProvince = data.salary_pricelist_province
          this.office_vplk_id = this.listSalaryPricelistProvince[0].office_vplk
          this.selectedState = this.listSalaryPricelistProvince[0].state
          this.office_tpl_code = this.listSalaryPricelistProvince[0].office_tpl.code
          this.office_tpl = this.listSalaryPricelistProvince[0].office_tpl.id
          this.salary_pricelist_province_id = this.listSalaryPricelistProvince[0].id
          this.price = this.listSalaryPricelistProvince[0].price
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 100%;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
